import React, {useState} from 'react'
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { Fragment } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setcurrentPair } from '../Trader/tradingSlice';
import { useNavigate } from 'react-router-dom';
import BalanceCard from '../Cards/BalanceCard';

const Assets = () => {

    const formatPrice = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);
    const coins = useSelector((state) => state.coins.coins);
    const coinRates = useSelector((state) => state.coins.coinRates);

    const [coinSymbol, setCoinSymbol] = useState('BINANCE:BTCUSDT');
    const availableCoins = ['XMR', 'USDT', 'USDTERC20', 'XLM', 'ETH', 'TRX', 'XRP', 'BTC', 'LTC', 'BCH', 'DOGE', 'DASH', 'BNB'];
    const fundings = useSelector((state) => state.wallet.fundings);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const tradings = useSelector((state) => state.history.tradings);
    const investments = useSelector((state) => state.history.investments);
    const withdrawals = useSelector((state) => state.history.withdrawals);

    const calculate24hrChange = (coin) => {
      let rate = 0;
      coinRates.forEach(coinRater => {
        if (coinRater.symbol === coin) {
          rate = parseFloat(coinRater.changePercent24Hr);
        }
      });

      return rate;
    }

    const calculateBalance = (coin) => {
      let amount = 0;

      fundings.forEach(fund => {
        if (fund.gateway === coin) {
          amount += parseFloat(fund.amount);
        }
        });

        tradings.forEach(trade => {
          if (trade.pair === coin) {
            amount += parseFloat(trade.profit);
          }
          });

          investments.forEach(investment => {
            if (investment.payment_source === coin && investment.status != 'declined') {
              amount -= parseFloat(investment.amount_invested);
            }
            });

            withdrawals.forEach(withdrawal => {
              
              if (withdrawal.source === coin && withdrawal.status != 'declined') {
                amount -= parseFloat(withdrawal.amount);
              }
              });
      
        return amount;
    }

    // Check if there are any assets with balance > 0
    const hasAssets = coinRates.length > 0 && coinRates.some((coin) => calculateBalance(coin.symbol) > 0);
    
  return (
    <div style={{marginTop: '75px'}}>
      {/* <Cards/> */}
      
      {/* <Card>
        <CardActions sx={{justifyContent: 'space-between', paddingX: '15px'}}>
        <WithdrawalButton/>
        <WalletButton/> 
        </CardActions>
      </Card> */}

      {/* <MobileMenu/> */}

      <BalanceCard/>

        {coinRates.length < 1 &&
        <CircularProgress/>
        }
        {coinRates.length > 0 && !hasAssets && (
          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center', 
            padding: 4,
            textAlign: 'center'
          }}>
            <Typography sx={{ 
              fontSize: 18, 
              color: 'text.secondary',
              mb: 1
            }}>
              No Assets
            </Typography>
            <Typography sx={{ 
              fontSize: 14, 
              color: 'text.secondary',
              opacity: 0.7
            }}>
              You don't have any assets yet. Start by funding your wallet to see your assets here.
            </Typography>
          </Box>
        )}
        {coinRates.length > 0 && hasAssets && 

        <List sx={{ width: '100%', bgcolor: 'transparent' }}>

            {coinRates.map((coin) =>(
              calculateBalance(coin.symbol) > 0 &&
                <Fragment key={coin.symbol}>
                <ListItem alignItems="flex-start" sx={{cursor: 'pointer'}}
                onClick={()=>{
                  if (coin.symbol === 'USDT') {
                    dispatch(setcurrentPair('BTC'));
                  }else{
                    dispatch(setcurrentPair(coin.symbol));
                  }
                  
                  setTimeout(() => {
                    navigate('/trade');
                  }, 100);
              }}
                >
          <ListItemAvatar>
          
            <Avatar alt="Coin Name"
            src={`https://assets.coincap.io/assets/icons/${coin.symbol.toLowerCase()}@2x.png`}
            />
        </ListItemAvatar>
                <ListItemText
                  primary={coin.symbol}
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: 'inline' }}
                        component="span"
                        variant="body2"
                        color="text.primary"
                      >
                        {coin.name}
                      </Typography>
                    </React.Fragment>
                  }
                />

                <Box edge="end" sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignContent: 'flex-start', alignItems: 'flex-start'}}>
                    <Typography mx={1}>
                    {formatPrice(coin.priceUsd)}
                    </Typography>

                    <Typography mx={1} sx={{display: 'flex', justifyContent: 'space-between'}}>
                    
                    <Typography style={{fontWeight: 'lighter', color: `${calculate24hrChange(coin.symbol) > 0 ? '#13e576' : '#e8073c'}`}} variant="caption" display="block" gutterBottom>
                          {calculate24hrChange(coin.symbol).toFixed(2)}
                        </Typography>
                     <Typography style={{marginLeft: '2px'}} variant="caption" display="block" gutterBottom>
                          24hr
                        </Typography> 
                    </Typography>
                </Box>

                <Box edge="end" sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignContent: 'flex-start', alignItems: 'flex-start'}}>
                    <Typography mx={1} sx={{fontWeight: 'bolder'}}>
                    {/* {formatPrice(coin.priceUsd)} */}
                    {formatPrice(calculateBalance(coin.symbol))}
                    </Typography>

                    <Typography mx={1} variant="caption">
                    {(calculateBalance(coin.symbol)/coin.priceUsd).toFixed(8)}
                    </Typography>
                </Box>
                
              </ListItem>
              <Divider variant="inset" component="li" />
              </Fragment>
            ))}
        
        
  
      </List>
        
        }
      

            
    </div>
  )
}

export default Assets
